import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type DeveloperToolsStoreShared = {
  useCmsPreview: boolean;
  logHttpCalls: boolean;
  setUseCmsPreview: (arg: boolean) => void;
  setLogHttpCalls: (arg: boolean) => void;
};

export type DeveloperToolsStoreCare = DeveloperToolsStoreShared & {
  showPerformanceInsights: boolean;
  setShowPerformanceInsights: (arg: boolean) => void;
};

export const useDeveloperToolsStore = create<DeveloperToolsStoreShared>()(
  persist(
    set => ({
      useCmsPreview: false,
      logHttpCalls: false,
      setUseCmsPreview: (arg: boolean) => set({ useCmsPreview: arg }),
      setLogHttpCalls: (arg: boolean) => set({ logHttpCalls: arg }),
    }),
    {
      storage: createJSONStorage(() => localStorage),
      name: "developer-tools-store",
    },
  ),
);

export const useDeveloperToolsStoreCare = create<DeveloperToolsStoreCare>()(
  persist(
    set => ({
      // Include shared store defaults
      useCmsPreview: false,
      logHttpCalls: false,
      setUseCmsPreview: (arg: boolean) => set({ useCmsPreview: arg }),
      setLogHttpCalls: (arg: boolean) => set({ logHttpCalls: arg }),

      // Care specific state
      showPerformanceInsights: false,
      setShowPerformanceInsights: (arg: boolean) => set({ showPerformanceInsights: arg }),
    }),
    {
      storage: createJSONStorage(() => localStorage),
      name: "developer-tools-store-care",
    },
  ),
);
